import { render } from "./beneficiary_dashboard.html?vue&type=template&id=3ba9aa0d&external"
import script from "./beneficiary_dashboard.js?vue&type=script&lang=js&external"
export * from "./beneficiary_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__